<template>
    <base-layout
        :header-type="headerType.ALL"
        :unsaved-puri-count="unsavedPuriCount"
        :latest-image-id="latestImageId"
        :footer-type="footerType.PRIMARY"
    >
        <div class="is-flex-wrap">
            <template v-if="isCompleted">
                <div v-if="articleData" class="p-puriNews" data-jest="article">

                    <!-- プラポリ同意取得モーダル -->
                    <wrapper-modal-privacy-policy-agreement />

                    <div
                        class="p-puriNews-article"
                        v-html="articleData.content.rendered"
                        @click="handleArticleClickEvent"
                    ></div>
                    <div class="p-puriNews-share">
                        <div>
                            <a :href="shareUrlForLine" @click="ga4ClickEvent(shareUrlForLine, shareLineAlt)" data-jest="share-line"><img :src="`${imgUrl}btn_icon_line.svg`" alt="LINEで送る"/></a>
                        </div>
                        <div>
                            <a :href="shareUrlForTwitter" target="_blank" @click="ga4ClickEvent(shareUrlForTwitter, shareTwitterAlt)" data-jest="share-twitter"><img :src="`${imgUrl}btn_icon_twitter_x.png`" alt="ポストする"/></a>
                        </div>
                        <div>
                            <a :href="shareUrlForFacebook" rel="nofollow" target="_blank" @click="ga4ClickEvent(shareUrlForFacebook, shareFaceBookAlt)" data-jest="share-facebook"><img :src="`${imgUrl}btn_icon_facebook.svg`" alt="シェアする"/></a>
                        </div>
                        <div>
                            <a class="copy-btn" @click="writeToClipboard(pageUrl)"><img :src="`${imgUrl}btn_icon_copy.svg`" :alt="copyAlt"/></a>
                        </div>
                    </div>
                </div>
                <error-not-found-content v-else data-jest="error"/>
            </template>
            <loading-heart v-else data-jest="loading"/>
        </div>
    </base-layout>
</template>
<script>
    import BaseLayout from "../templates/BaseLayout.vue"
    import ErrorNotFoundContent from '../organisms/ErrorNotFoundContent.vue'
    import * as urlUtil from '../../util/UrlUtil'
    import * as puriNewsAction from '../../model/action/PuriNewsAction.js'
    import * as metaInformationUtil from "../../util/metaInformationUtil.js";
    import WrapperModalPrivacyPolicyAgreement from "../organisms/WrapperModalPrivacyPolicyAgreement.vue";
    import {
        getClickAllEvent,
        getScrollEvent,
        getPageUrl
    } from "../../util/Ga4EventUtil.js";
    import LoadingHeart from "../atoms/LoadingHeart.vue"
    import {headerType} from "../../view-model/enum/HeaderType";
    import {footerType} from "../../view-model/enum/FooterType";
    import {mapActions} from "vuex"

    export default {
        name: "PuriNewsDetail",
        props: {
            /**
             * Headerコンポーネント用
             * 未保存プリ数
             */
            unsavedPuriCount: {
                type: String,
                required: true
            },
            /**
             * Headerコンポーネント用
             * 最新プリID
             */
            latestImageId: {
                type: String,
                required: true
            },
            id: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                headerType: headerType,
                footerType: footerType,
                isCompleted: false,
                articleData: null,
                articleTitle: '',
                imgUrl: '/img/icon/',
                pageUrl: `${urlUtil.productUrlUtil.productDomain()}/sp/puri_news#/${this.id}`,
                shareLineAlt: 'LINEで送る',
                shareTwitterAlt: 'ポストする',
                shareFaceBookAlt: 'シェアする',
                copyAlt: 'URLをコピー'
            }
        },
        mounted() {
            /**
             * TheHeader,TheFooterでstoreのaccountStatusを使用するため、予めstoreに保存しておく
             * FIXME:ここでの取得を忘れてもエラーが出ず気づかない可能性があるため、VOYAGERFRONT-5558で修正予定
             */
            this.getAccountStatus()
        },
        created() {
            this.getArticleListData()
        },
        updated() {
            /**
             * 記事本文内のリンク付きaタグにclick_allイベント送信設定
             * WordPressプラグインに仕込んだjs-ga4-click-allを取得しgtag送信を行っている
             */
            const pageUrl = getPageUrl(this.$route.path)
            const targetClassName = [...document.getElementsByClassName('js-ga4-click-all')];
            targetClassName.forEach((val) => {
                val.addEventListener('click', (e) => {
                    e.preventDefault();
                    gtag('event', 'click_all', {
                        'pageUrl': pageUrl,
                        'elementUrl': val.href,
                        'elementText': val.innerText
                    })
                    location.href = val.href
                });
            });
        },
        components: {
            BaseLayout, ErrorNotFoundContent, WrapperModalPrivacyPolicyAgreement, LoadingHeart
        },
        watch: {
            id() {
                this.isCompleted = false
                /**
                 * FIXME
                 * getArticleListData()しなおす方が適切だが、
                 * 現状getScrollEvent()内で設定したEventListenerを適切にremoveする処理が思いつかないので、
                 * 応急処置としてリロードさせている
                 */
                location.reload()
            }
        },
        methods: {
            ...mapActions({
                getAccountStatus: 'AccountStoreV2/getAccountStatus'
            }),
            getArticleListData() {
                puriNewsAction.getArticleData(this.id).then((result) => {
                    this.articleData = result.articleData
                    this.articleTitle = result.articleTitle
                    this.isCompleted = true
                    getScrollEvent()
                    // 記事meta情報をセット
                    this.setMetaDataForSPA(result.articleTitle, this.pageUrl)
                }).catch((err) => {
                    console.log(err)
                    this.isCompleted = true
                })
            },
            writeToClipboard(text) {
                this.ga4ClickEvent('', this.copyAlt)
                navigator.clipboard.writeText(text).then((e) => {
                    const element = document.querySelectorAll('.copy-btn')
                    element[0].setAttribute('class','copy-btn tooltip')

                    // アニメーション反復させるためにアニメーション終了後に.tooltip都度削除
                    const tooltip = document.querySelectorAll('.tooltip')
                    tooltip[0].addEventListener('animationend', (e) => {
                        e.target.setAttribute('class','copy-btn')
                    })
                }).catch((err) => {
                    console.error(err)
                })
            },
            setMetaDataForSPA(title, url) {
                metaInformationUtil.setTitleAndDescription(title, '')
                /**
                 * SNSのクローラーでJavaScript読み込んでくれなかったのでコメントアウト
                 * 経緯追いやすいよう残しておく => VOYAGERFRONT-2838
                 */
                // SPAの動的なページのためmetaInformationUtilで対処できないmeta情報を追加でセット
                // document.querySelector("meta[property='og:title']").setAttribute('content', title)
                // document.querySelector("meta[name='twitter:title']").setAttribute('content', title)
                // document.querySelector("meta[property='og:url']").setAttribute('content', url)
            },
            ga4ClickEvent(elUrl, elAlt) {
                getClickAllEvent(elUrl, elAlt)
            },

            handleArticleClickEvent(event) {
                if (event.target.id === 'calendar-install-btn-line') {
                    this.sendLineEvent();
                }
                if (event.target.classList.contains('calendar-install-btn-insta')) {
                    this.sendMetaEvent();
                }
                if (event.target.classList.contains('calendar-install-btn-x')) {
                    this.sendXEvent();
                }
            },
            /**
             * デジマ課の広告の計測用 https://furyu.atlassian.net/browse/PICTSITE-396
             * のイベント送信を行う。
             */
            sendLineEvent() {
                _lt('send', 'cv', {
                    type: 'calendarbuttontap'
                },['45f1ef0a-41da-484a-851f-b10da425248c']);
            },
            /**
             * デジマ課の広告の計測用 https://furyu.atlassian.net/browse/SUGAR-60
             * のイベント送信を行う。
             */
            sendMetaEvent() {
                fbq('track', 'SubmitApplication');
            },
            /**
             * デジマ課の広告の計測用 https://furyu.atlassian.net/browse/SUGAR-60
             * のイベント送信を行う。
             */
            sendXEvent() {
                // Insert X Event ID for Pictlink Calendar
                twq('event', 'tw-oc74z-pku7f', {});
            },
        },
        computed: {
            shareUrlForTwitter() {
                return 'https://twitter.com/intent/tweet?text=' + this.articleTitle + '&url=' + encodeURIComponent(this.pageUrl)
            },
            shareUrlForFacebook() {
                return 'http://www.facebook.com/share.php?u=' + encodeURIComponent(this.pageUrl)
            },
            shareUrlForLine() {
                return 'https://timeline.line.me/social-plugin/share?url=' + encodeURIComponent(this.pageUrl)
            }
        }
    }
</script>
<style lang="scss" scoped>
    @use "../../../scss/v2/base/variables";
    .p-puriNews-article {
        :deep(div) {
            &:first-child {
                margin-top: -2.135vw;
            }
        }

        :deep(.l-element.m-heading-section.is-full-width) {
            margin-top: 2.135vw;

            &:first-child {
                margin-top: -2.135vw;
            }
        }

        :deep(.wp-image) {
            padding-top: 2.135vw;
            padding-bottom: 2.135vw;
            margin-right: -2.135vw;
            margin-left: -2.135vw;

            &:first-child {
                margin-top: -4.27vw;
            }
        }

        :deep(.l-element) {
            p {
                &:last-child {
                    margin-bottom: 0;
                }
            }
        }

        :deep(.yt-video) {
            width: 88%;
            margin: 8px auto 8px;
        }
    }

    .p-puriNews-share {
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        padding: 4.27vw 0 2.135vw 0;
        position: relative;

        img {
            width: 40px;
            height: auto;
        }

        .copy-btn {
            position: relative;
        }

        .tooltip::after {
            content: 'コピーしました';
            display: inline-block;
            width: 72px;
            text-align: center;
            color: variables.$color-pictlink-black;
            font-size: 1rem;
            line-height: 1.5;
            background: linear-gradient(transparent 50%, rgba(variables.$color-pictlink-pink, variables.$opacity-30) 0%);
            position: absolute;
            left: -14px;
            top: -44px;
            animation: fade-tooltip .5s 1.3s 1 forwards;
        }

        @keyframes fade-tooltip {
            to { opacity: variables.$opacity-0; }
        }
    }
</style>
